import React, {Component} from 'react';
import styles from './SearchWidget.module.scss';
import {withTranslation} from "react-i18next";
import BookFlight from "./BookFlight/BookFlight";
import * as PropTypes from "prop-types";
import Tabs from "../Common/Tabs/Tabs";
import Tab from "../Common/Tabs/Tab/Tab";
import ManageTripForm from "./ManageTripForm/ManageTripForm";
import CheckInForm from "./CheckInForm/CheckInForm";
import ExternalLinks from "./ExternalLinks/ExternalLinks";

class SearchWidget extends Component {

    render() {
        const {t} = this.props;

        return (
            <div className={styles.searchWidgetContainer} id={'search-widget-container'}>
                <Tabs>
                    <Tab title={t('Book')+ ' ' + t('Flight').toUpperCase()} id={'book-flight'} isDefault>
                        <BookFlight/>
                    </Tab>
                    <Tab title={t('Manage') + ' ' + t('Trip').toUpperCase()} id={'manage-trip'}>
                        <ManageTripForm/>
                    </Tab>
                    <Tab title={t('Online') + ' ' + t('Check-in').toUpperCase()} id={'online-check-in'}>
                        <CheckInForm/>
                    </Tab>
                </Tabs>
                <ExternalLinks/>
            </div>
        );
    }
}

SearchWidget.propTypes = {
    t: PropTypes.any
};

SearchWidget.defaultProps = {
    t: s => s
};

export default withTranslation()(SearchWidget);